import { getConsentState as getConsentState$3 } from './aus/getConsentState.js';
import { getCurrentFramework } from './getCurrentFramework.js';
import { getGpcSignal } from './lib/signals.js';
import { getConsentState as getConsentState$1 } from './tcfv2/getConsentState.js';
import { getConsentState as getConsentState$2 } from './usnat/getConsentState.js';
const callBackQueue = [];
const finalCallbackQueue = [];
const awaitingUserInteractionInTCFv2 = (state) => state.tcfv2?.eventStatus === "cmpuishown";
const awaitingUserInteractionInUSNAT = (state) => state.usnat?.signalStatus === "not ready";
const invokeCallback = (callback, state) => {
    if (awaitingUserInteractionInTCFv2(state) || awaitingUserInteractionInUSNAT(state)) {
        return;
    }
    const stateString = JSON.stringify(state);
    if (stateString !== callback.lastState) {
        callback.fn(state);
        callback.lastState = stateString;
    }
};
const enhanceConsentState = (consentState) => {
    const gpcSignal = getGpcSignal();
    if (consentState.tcfv2) {
        const consents = consentState.tcfv2.consents;
        return {
            ...consentState,
            canTarget: Object.keys(consents).length > 0 && Object.values(consents).every(Boolean),
            framework: "tcfv2",
            gpcSignal
        };
    }
    else if (consentState.usnat) {
        return {
            ...consentState,
            canTarget: !consentState.usnat.doNotSell,
            framework: "usnat",
            gpcSignal
        };
    }
    else if (consentState.aus) {
        return {
            ...consentState,
            canTarget: consentState.aus.personalisedAdvertising,
            framework: "aus",
            gpcSignal
        };
    }
    return {
        ...consentState,
        canTarget: false,
        framework: null,
        gpcSignal
    };
};
const getConsentState = async () => {
    switch (getCurrentFramework()) {
        case "aus":
            return enhanceConsentState({ aus: await getConsentState$3() });
        case "usnat": {
            return enhanceConsentState({
                usnat: await getConsentState$2()
            });
        }
        case "tcfv2":
            return enhanceConsentState({ tcfv2: await getConsentState$1() });
        default:
            throw new Error("no IAB consent framework found on the page");
    }
};
const invokeCallbacks = () => {
    const callbacksToInvoke = callBackQueue.concat(finalCallbackQueue);
    if (callbacksToInvoke.length === 0) {
        return;
    }
    void getConsentState().then((state) => {
        if (awaitingUserInteractionInTCFv2(state) || awaitingUserInteractionInUSNAT(state)) {
            return;
        }
        callbacksToInvoke.forEach((callback) => invokeCallback(callback, state));
    });
};
const onConsentChange = (callBack, final = false) => {
    const newCallback = { fn: callBack };
    if (final) {
        finalCallbackQueue.push(newCallback);
    }
    else {
        callBackQueue.push(newCallback);
    }
    void getConsentState().then((consentState) => {
        invokeCallback(newCallback, consentState);
    }).catch(() => {
    });
};
export { invokeCallbacks, onConsentChange };
